import React from 'react';
import SvgIcon from './SvgIcon';

const Drought = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M.5 23.5h23M23.5 14.5H.5M2.937 14.5L8 18.5s-3.959 5-3.833 5M13.75 14.5l1.708 4.5-3.058 2.117a1 1 0 01-1.2-.042L8 18.5l1.5-4M15.458 19l4.042-1.799 4 6.299M.5 20l5.125-3.376"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.5 23.5l2-6.299 2.562-2.701M6 9.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM18.5 14.5V1M18.5 7l2-1 1-4M20.5 6l3-2M18.5 10l-2-1-1-4M16.5 9l-3-2"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Drought.displayName = 'DroughtIcon';

export default Drought;
